<template>
  <section id="paginations">
    <div class="demo">
      <h5>Pagination</h5>
      <label>Less than 5 pages</label>
      <nav aria-label="Search results pages">
        <ul class="pagination" role="pagination">
          <li class="page-item active">
            <a class="page-link" href="#">1
              <span class="sr-only">(current)</span></a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">2</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">3</a>
          </li>
        </ul>
      </nav>
      <label>More than 5 pages</label>
      <nav aria-label="Search results pages">
        <ul class="pagination" role="pagination">
          <li class="page-item disabled">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="left" data-original-title="First">
              <span class="sr-only">First</span>
              <i class="gel-icon-left-end gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item disabled">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Previous">
              <span class="sr-only">Previous</span>
              <i class="gel-icon-angle-left gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item active">
            <a class="page-link" href="#">1
              <span class="sr-only">(current)</span></a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">2</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">3</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">4</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">5</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Next">
              <span class="sr-only">Next</span>
              <i class="gel-icon-angle-right gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="right" data-original-title="Last">
              <span class="sr-only">Last</span>
              <i class="gel-icon-right-end gel-icon-xs"></i>
            </a>
          </li>
        </ul>
      </nav>
      <nav aria-label="Search results pages">
        <ul class="pagination" role="pagination">
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="left" data-original-title="First">
              <span class="sr-only">First</span>
              <i class="gel-icon-left-end gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Previous">
              <span class="sr-only">Previous</span>
              <i class="gel-icon-angle-left gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">10
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">11</a>
          </li>
          <li class="page-item active">
            <a class="page-link" href="#">12
              <span class="sr-only">(current)</span></a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">13</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">14</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Next">
              <span class="sr-only">Next</span>
              <i class="gel-icon-angle-right gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="right" data-original-title="Last">
              <span class="sr-only">Last</span>
              <i class="gel-icon-right-end gel-icon-xs"></i>
            </a>
          </li>
        </ul>
      </nav>
      <nav aria-label="Search results pages">
        <ul class="pagination" role="pagination">
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="left" data-original-title="First">
              <span class="sr-only">First</span>
              <i class="gel-icon-left-end gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Previous">
              <span class="sr-only">Previous</span>
              <i class="gel-icon-angle-left gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">21
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">22</a>
          </li>
          <li class="page-item active">
            <a class="page-link" href="#">23
              <span class="sr-only">(current)</span></a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">24</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">25</a>
          </li>
          <li class="page-item disabled">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Next">
              <span class="sr-only">Next</span>
              <i class="gel-icon-angle-right gel-icon-xs"></i>
            </a>
          </li>
          <li class="page-item disabled">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="right" data-original-title="Last">
              <span class="sr-only">Last</span>
              <i class="gel-icon-right-end gel-icon-xs"></i>
            </a>
          </li>
        </ul>
      </nav>
      <hr class="sg-hr">
      <h5 class="mt-3">Inline</h5>
      <nav aria-label="Search results pages">
        <ul class="pagination pagination-inline" role="pagination">
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="left" data-original-title="First">
              <span class="sr-only">First</span>
              <i class="gel-icon-left-end gel-icon-sm"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Previous">
              <span class="sr-only">Previous</span>
              <i class="gel-icon-angle-left gel-icon-sm"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">10
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">11</a>
          </li>
          <li class="page-item active">
            <a class="page-link" href="#">12
              <span class="sr-only">(current)</span></a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">13</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#">14</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="top" data-original-title="Next">
              <span class="sr-only">Next</span>
              <i class="gel-icon-angle-right gel-icon-sm"></i>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" data-toggle="tooltip" data-placement="right" data-original-title="Last">
              <span class="sr-only">Last</span>
              <i class="gel-icon-right-end gel-icon-sm"></i>
            </a>
          </li>
        </ul>
      </nav>
      <hr class="sg-hr">
      <h5>Pager</h5>
      <p class="d-flex justify-content-between">
        <button type="button" class="btn btn-ctrl">
          <i class="gel-icon-angle-left"></i>
          Previous
        </button>
        <button type="button" class="btn btn-ctrl">Next
          <i class="gel-icon-angle-right"></i>
        </button>
      </p>
    </div>
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import mdfile from "@/docs/components/paginations.md";
export default {
  name: "paginations",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.paginations.name);
    this.$emit("update-tagline", this.$root.yamlData.components.paginations.description);
  },
  mounted: function () {
    const pageItems = document.querySelectorAll('[data-toggle="tooltip"]')
    pageItems.forEach(pageItem => {
      new BSN.Tooltip(pageItem)
    })
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
